import PropTypes from 'prop-types'
import React, { Component } from 'react'
import InputWithLimit from 'components/Customize/InputWithLimit'
import { injectIntl, defineMessages } from 'react-intl'
import EmailCapturePreview from '../../../EmailCapturePreview'
import cx from 'classnames'

import style from './style'

const messages = defineMessages({
  emailCaptureMessage: {
    id: 'app.widget.emailCaptureMessage',
    description:'Message sent to the user asking them for their email address',
    defaultMessage:"Hey there! We're excited to help you out. Let us know your email address so that we can follow up in case we get disconnected."
  }
})

class EmailCapture extends Component {

  constructor(props) {
    super(props)

    this.onMessageChanged = this.onMessageChanged.bind(this)

    this.state = {
      message: props.message
    }
  }

  onMessageChanged(message, isValid) {
    if (!isValid) return

    this.setState({ message })
    this.props.onMessageChanged(message)
  }

  render() {
    const { message } = this.state
    const { intl, className, name, avatarUrl, backgroundColor } = this.props
    const placeholderMessage = intl.formatMessage(messages.emailCaptureMessage)

    return (
      <div className={cx(style.EmailCapture, className)}>
        <InputWithLimit
          title="Email Capture Text"
          text={message}
          placeholder={placeholderMessage}
          maxLength={200}
          invalidLabel="You have entered too many characters"
          onChange={this.onMessageChanged}
          className="email-capture-input"
        />
        <EmailCapturePreview
          name={name}
          message={message || placeholderMessage}
          avatarUrl={avatarUrl}
          backgroundColor={backgroundColor}
          className="email-capture-preview"
        />
      </div>
    )
  }
}

export default injectIntl(EmailCapture)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/Advanced/components/EmailCapture/index.js